//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            result: {
                stars: 0,
                skipped: true
            }
        };
    },

    mounted () {
        this.$store.commit('hideHTMLElements');
    },

    destroyed () {
        this.$store.commit('showHTMLElements');
    }
};
